import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import SEO from "../components/SEO";

export default function BookingCancelledPage() {
  return (
    <>
      <SEO path="/booking/cancelled" title="Booking Cancelled | Nexora" description="Nexora booking cancelled." noindex />
      <section className="max-w-3xl mx-auto px-4 sm:px-6 py-20 lg:py-28" data-testid="booking-cancelled-page">
        <div className="rounded-[2rem] bg-white border border-slate-200 p-8 sm:p-12 text-center shadow-sm">
          <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-slate-100">
            <XCircle className="h-9 w-9 text-slate-400" />
          </span>
          <h1 className="mt-6 font-display text-3xl sm:text-4xl font-extrabold tracking-tight" style={{ color: "#123B6D" }}>
            Payment cancelled — your spot was not reserved.
          </h1>
          <p className="mt-3 text-sm text-slate-600 max-w-md mx-auto">
            No charge was made. Your seat hold expires automatically, so if you'd
            still like to enroll, you can start again any time.
          </p>
          <div className="mt-8 flex flex-wrap justify-center gap-3">
            <Link
              to="/classes"
              className="inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-bold text-white"
              style={{ backgroundColor: "#FF8C42" }}
              data-testid="booking-cancelled-back-btn"
            >
              Back to classes
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 rounded-full px-6 py-3 text-sm font-bold border-2"
              style={{ borderColor: "#00A6B2", color: "#00A6B2" }}
            >
              Contact us
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
